import {
  GET_DEFENSES,
  GET_DEFENSES_FAIL,
  GET_DEFENSES_SUCCESS,
  ADD_NEW_DEFENSE,
  ADD_DEFENSE_SUCCESS,
  ADD_DEFENSE_FAIL,
  UPDATE_DEFENSE,
  UPDATE_DEFENSE_SUCCESS,
  UPDATE_DEFENSE_FAIL,
  DELETE_DEFENSE,
  DELETE_DEFENSE_SUCCESS,
  DELETE_DEFENSE_FAIL,
  
} from "./actionTypes";

export const getDefenses = () => ({
  type: GET_DEFENSES,
})

export const getDefensesSuccess = defenses => ({
  type: GET_DEFENSES_SUCCESS,
  payload: defenses,
})

export const getDefensesFail = error => ({
  type: GET_DEFENSES_FAIL,
  payload: error,
})

export const addNewDefense = data => ({
  type: ADD_NEW_DEFENSE,
  payload: data,
})

export const addDefenseSuccess = defense => ({
  type: ADD_DEFENSE_SUCCESS,
  payload: defense,
})

export const addDefenseFail = error => ({
  type: ADD_DEFENSE_FAIL,
  payload: error,
})

export const updateDefense = defense => ({
  type: UPDATE_DEFENSE,
  payload: defense,
})

export const updateDefenseSuccess = defense => ({
  type: UPDATE_DEFENSE_SUCCESS,
  payload: defense,
})

export const updateDefenseFail = error => ({
  type: UPDATE_DEFENSE_FAIL,
  payload: error,
})

export const deleteDefense = data => ({
  type: DELETE_DEFENSE,
  payload: data,
})

export const deleteDefenseSuccess = data => ({
  type: DELETE_DEFENSE_SUCCESS,
  payload: data,
})

export const deleteDefenseFail = error => ({
  type: DELETE_DEFENSE_FAIL,
  payload: error,
})

